import { useState } from 'react';
import IngredientAPI from '../services/ingredient.api.services';
import useAlert from './Alert/useAlert';
import DateInput from './input/DateInput';
import { NumberInput } from './input/NumberInput';
import { SubmitButton } from './SubmitButton';
import { TextInput } from './input/TextInput';
import Title from './Title';


export const CreateIngredientForm = ({customer}) => {
    const defaultState = {
        name: '',
        description: '',
        quantity: '',
        expires: null,
        loading: false,
    };

    const {showSuccessAlert, showErrorAlert} = useAlert();
    const [state, setState] = useState({...defaultState});
    const changeState = partialState => setState(currentState => ({...currentState, ...partialState}));

    const handleSubmit = () => {
        changeState({loading: true})
        IngredientAPI
            .postIngredient({
                customer: customer.id,
                name: state.name,
                description: state.description,
                quantity: state.quantity,
                expires: state.expires,
            })
            .then(() => {
                showSuccessAlert('NFT successfully generated');
                changeState({...defaultState});
            })
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => changeState({loading: false}))
    }

    return <>
        <Title>Fill the NFT basic ingredient to create</Title>
        <TextInput
            label="NFTBasicIngredientName"
            value={state.name}
            onChange={name => changeState({name})}
        />
        <TextInput
            label="NFTBasicIngredientDescription"
            value={state.description}
            onChange={description => changeState({description})}
        />
        <NumberInput
            label="Quantity"
            value={state.quantity}
            onChange={quantity => changeState({quantity})}
        />
        <DateInput
            label="NFT Basic Ingredients Expiring"
            value={state.expires}
            onChange={expires => changeState({expires})}
        />
        <SubmitButton
            text="NFT GENERATION"
            loading={state.loading}
            disabled={!customer || !state.name || !state.description ||!state.quantity ||!state.expires || state.loading}
            handleSubmit={handleSubmit}
        />
    </>;
}
